import {
    Component,
    ContentChildren,
    ElementRef,
    EventEmitter,
    Input,
    OnInit,
    Output,
    QueryList,
    ViewChild
} from "@angular/core";
import {ResponsiveService} from "../../orchestration/responsive.service";
import {PageFooterControlDirective} from "../page-footer-control.directive";
import {NavigationService} from "../../orchestration/navigation.service";
import {IconButtonType} from "../../buttons/icon-button/icon-button";
import {Page, PageAlignment, PageLayout} from "../../orchestration/page";
import {ThemeModel} from "../../theme/theme.model";
import {SessionEvents} from "../../orchestration/session-events";
import {AppData, ColorPairData} from "../../orchestration/app-entity.model";

@Component({
    selector: "woa-full-page-layout",
    templateUrl: "full-page-layout.component.html",
    providers: [{provide: PageLayout, useExisting: FullPageLayoutComponent}]
})
export class FullPageLayoutComponent extends PageLayout implements OnInit {
    // navbar options
    @Input() showNavbar: boolean = true;
    @Input() showNavbarLogo: boolean;
    @Input() autoDismissOnBack: boolean = true;
    @Input() hideBackButton: boolean = false;
    @Input() makeFloatingBackButtonCircular: boolean = true;
    @Input() showBackButtonOnDesktop: boolean = true;
    @Input() showRefreshButton: boolean = false;
    @Input() enableSwipeRefresh: boolean = false;
    @Input() showExitButton: boolean = false;
    @Input() showTitles: boolean = true;
    @Input() showSubtitle: boolean = true;
    @Input() navbarTitle: string;
    @Input() title: string;
    @Input() subtitle: string;
    @Input() translationParams: any = {};

    // page background options
    @Input() transparent: boolean = false;
    @Input() showLoginBackgroundImage: boolean = false;
    @Input() backgroundColorPair: string = "standard-page";

    // page content options
    @Input() pillarboxedOnMobile: "mobile" | "none" = "mobile";
    @Input() pillarboxedOnDesktop: "mobile" | "desktop" | "double-mobile" | "none" = "mobile";
    @Input() showContent = true;
    @Input() contentLocked: boolean = false;

    // footer options
    @Input() showFooter: boolean = true;
    @Input() showFooterShadow: boolean;
    @Input() allowSafeArea: boolean = true;

    @Output() backgroundImageApplied: EventEmitter<void> = new EventEmitter();
    @Output() onBack: EventEmitter<void> = new EventEmitter();
    @Output() onRefresh: EventEmitter<void> = new EventEmitter();
    @Output() onExit: EventEmitter<void> = new EventEmitter();

    @ViewChild("content", {read: ElementRef}) public contentElementRef: ElementRef;
    @ViewChild("scroller", {read: ElementRef}) public scrollerElementRef: ElementRef;

    @ContentChildren(PageFooterControlDirective) footerControls: QueryList<any>;

    IconButtonType = IconButtonType;
    SessionEvents = SessionEvents;

    private scrollPositionStack: number[] = [];

    constructor(public page: Page,
                public navigationService: NavigationService,
                public responsiveService: ResponsiveService,
                private themeModel: ThemeModel) {
        super();
    }

    ngOnInit(): void {
        this.page.containerComponentRef && this.page.containerComponentRef.instance.geometry$.next({alignment: PageAlignment.FULL});

        const standardPageHeader: ColorPairData = this.themeModel.getPaletteEntry("standard-page-header");
        if (standardPageHeader) {
            const metaTag: Element = document.querySelector("meta[name='theme-color']");
            metaTag.setAttribute("content", standardPageHeader.backgroundColor);
        }
    }

    async back(): Promise<any> {
        this.onBack.emit();
        if (this.autoDismissOnBack) {
            return this.navigationService.dismissView();
        }
    }

    // Used to clarify type after use of async in template
    appData(appData: AppData): AppData {
        return appData;
    }

    public pushScrollPosition(): void {
        this.scrollPositionStack.push(this.scrollerElementRef.nativeElement.scrollTop);
        this.scrollerElementRef.nativeElement.scrollTop = 0;
    }

    public popScrollPosition(): void {
        if (this.scrollPositionStack.length) {

            // Interrupt any scrolling in progress else safari gets into a buggy state
            this.scrollerElementRef.nativeElement.style.overflow = "hidden";
            setTimeout(() => {
                this.scrollerElementRef.nativeElement.style.overflow = null;
                this.scrollerElementRef.nativeElement.scrollTop = this.scrollPositionStack.pop();
            }, 50);

        }
    }

    public async fadeOutAndIn(): Promise<void> {
        return new Promise<void>((resolve) => {
            this.scrollerElementRef.nativeElement.classList.add("faded-out");
            setTimeout(() => {
                this.scrollerElementRef.nativeElement.classList.remove("faded-out");
                resolve();
            }, 200);
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/page-layout/full-page-layout/full-page-layout.component.ts